export function confirmAction(message: string): boolean {
  return window.confirm(message);
}
